import React from 'react';
import Chart from 'react-apexcharts';


const SlotTypeBreakdown = ({ typeBreakdown, slots, hours }) => {
  const totalSlots = Object.values(typeBreakdown).reduce((a, b) => a + b, 0);

  const chartOptions = {
    chart: {
      type: 'donut',
      fontFamily: 'Manrope, sans-serif',
    },
    labels: [slots[0] , slots[1], slots[2], slots[3], slots[4], slots[5], slots[6]],
    colors: [
      'rgba(173, 137, 255, 0.5)', // Light purple
      'rgba(122, 94, 255, 0.7)',  // Slightly darker purple
      'rgba(97, 69, 255, 0.8)',   // Darker purple
      'rgba(65, 44, 165, 0.9)',   // Even darker purple
      'rgba(51, 34, 132, 1)',     // Darkest purple
      'rgba(34, 21, 85, 1)',      // Darkest purple
      'rgba(34, 21, 85, 1)',      // Darkest purple
    ],
    legend: {
      show: false, // Hide legend, we will create custom labels
    },
    plotOptions: {
      pie: {
        donut: {
          size: '85%', // Increased donut size
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Slots',
              formatter: function (value) {
                return totalSlots;
              },
              color: '#333',
              fontSize: '22px',
              fontWeight: 'bold',
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false, // Disable inner labels
    },
  };

  const chartSeries = [
    typeBreakdown[slots[0]],
    typeBreakdown[slots[1]],
    typeBreakdown[slots[2]],
    typeBreakdown[slots[3]],
    typeBreakdown[slots[4]],
    typeBreakdown[slots[5]],
    typeBreakdown[slots[6]],
  ];

  return (
    <div className="max-w-lg w-full bg-white rounded-lg shadow-md p-6 font-sans mx-auto sm:max-w-xl lg:max-w-2xl xl:max-w-3xl">
      <h5 className="text-xl font-bold leading-none text-gray-900 mb-3">Slot Type Breakdown</h5>
      <div className="flex justify-center items-center py-6">
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="donut"
          width="100%" // Keep width dynamic for responsiveness
          height="300px" // Adjust height to be responsive-friendly
        />
      </div>
      <div className="mt-6 text-center">
        {/* Top row with 3 columns, responsive */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-4">
          <div className="flex items-center justify-center">
            <span className="w-4 h-4 mr-2 rounded-full" style={{ backgroundColor: 'rgba(173, 137, 255, 0.5)' }}></span>
            <span className="text-sm">{slots[0]}</span>
          </div>
          <div className="flex items-center justify-center">
            <span className="w-4 h-4 mr-2 rounded-full" style={{ backgroundColor: 'rgba(122, 94, 255, 0.7)' }}></span>
            <span className="text-sm">{slots[1]}</span>
          </div>
          <div className="flex items-center justify-center">
            <span className="w-4 h-4 mr-2 rounded-full" style={{ backgroundColor: 'rgba(97, 69, 255, 0.8)' }}></span>
            <span className="text-sm">{slots[2]}</span>
          </div>
          <div className="flex items-center justify-center">
            <span className="w-4 h-4 mr-2 rounded-full" style={{ backgroundColor: 'rgba(65, 44, 165, 0.9)' }}></span>
            <span className="text-sm">{slots[3]}</span>
          </div>
        </div>

        {/* Bottom row with 2 columns, responsive */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-4">
          <div className="flex items-center justify-center">
            <span className="w-4 h-4 mr-2 rounded-full" style={{ backgroundColor: 'rgba(51, 34, 132, 1)' }}></span>
            <span className="text-sm">{slots[4]}</span>
          </div>
          <div className="flex items-center justify-center">
            <span className="w-4 h-4 mr-2 rounded-full" style={{ backgroundColor: 'rgba(34, 21, 85, 1)' }}></span>
            <span className="text-sm">{slots[5]}</span>
          </div>
          <div className="flex items-center justify-center">
            <span className="w-4 h-4 mr-2 rounded-full" style={{ backgroundColor: 'rgba(34, 21, 85, 1)' }}></span>
            <span className="text-sm">{slots[6]}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlotTypeBreakdown;
